<script setup lang="ts">
  import type { PropType } from 'vue';
  import type { Photo } from '@storefront/resources';

  defineOptions({
    inheritAttrs: false,
  });

  defineProps({
    header: String,
    content: String,
    headerType: { type: String },
    photos: { type: Array as PropType<Photo[]>, required: true },
    link: String,
    ariaLabel: String,
  });
</script>
<template>
  <SfSection class="photo-text">
    <div class="photo-text__photo-wrapper" v-if="photos?.length > 0 ">
      <MediaPicture :photo="photos" type="photo" class="photo-text__image" sizes="1104x834 2x max 576, 556x417 max 576, 1944x1458 2x max 992, 972x729 max 992, 1340x1004 2x, 670x502" />
      <a v-if="link" :href="link" :aria-label="ariaLabel " class="photo-text__link" :title="ariaLabel" />
    </div>
    <SfHeading :type="headerType || 'h2'" class="photo-text__header">
      {{ header }}
    </SfHeading>
    <QuillContent v-if="content" :content />
  </SfSection>
</template>
<style scoped lang="scss">
  @use "@storefront/styles/mixins/media";

  .photo-text {
    --section-content-gap: 1rem;

    &::after {
      content: '';
      clear: both;
      display: none;
    }

    &__header {
      margin-bottom: 1rem;
    }

    &__link {
      position: absolute;
      inset: 0;
    }

    &__photo-wrapper {
      position: relative;
      float: left;
      width: 50%;
      margin: 0 2rem 2rem 0;
    }

    :deep(.section__content) {
      display: block;

      .ql-editor {
        padding: unset;
        display: inline;
      }
    }
  }

  @include media.query(lg) {
    .photo-text {
      padding-left: 0.625rem;
      padding-right: 0.625rem;
      --section-content-gap: 0.5rem;

      &__header {
        margin-bottom: 0;
      }

      :deep(.section__content) {
        display: flex;
      }

      &__photo-wrapper {
        order: 1;
        float: none;
        width: 100%;
        margin: 1rem 0 0;
      }
    }
  }
</style>
